"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Switch = void 0;
const react_1 = __importStar(require("react"));
const switch_styles_1 = require("./switch.styles");
require("./switch.types");
exports.Switch = (0, react_1.memo)((0, react_1.forwardRef)((props, ref) => {
    const { value = false, label, onChange, name, labelDirection = 'normal', width, type = 'checkbox', disabled, hasBackground = true, testId = 'switch', } = props;
    return (react_1.default.createElement(switch_styles_1.SwitchLabel, { width: width, labelDirection: labelDirection, "data-testid": `${testId}-label` },
        label,
        react_1.default.createElement(switch_styles_1.StyledSwitcher, { hasBackground: hasBackground, disabled: disabled, checked: value },
            react_1.default.createElement("input", { ref: ref, disabled: disabled, type: type, checked: value, onChange: onChange, name: name, "data-testid": `${testId}-input` }))));
}));
